import { ErrorMessage, Field as Fieldmik, FieldArray } from 'formik';
import { Checkbox } from 'formik-semantic-ui';
import React, { useState } from 'react';
import { Label, Table } from 'semantic-ui-react';

import moment from 'moment';
import { MyNormalInput } from '../formikInput/input';
import TDSModal from './tdsModal';

const ActiveVendorBills = ({ viewmode, addPaidAmount }) => {
    const [modalActive, setModalActive] = useState(false);
    return (
        <div className="ui form tiny">
            <FieldArray
                name="activeVendorBills">
                {({ insert, replace, push, remove, form }) => {

                    const { initialValues, values, setFieldValue } = form
                    const { activeVendorBills } = values

                    let tempPayment = []
                    let selectedVendorBill = []

                    activeVendorBills && activeVendorBills.filter((item) => {

                        if (item.checkbox === true) {
                            selectedVendorBill.push(item)
                            tempPayment.push(item.payment ? item.payment : 0)
                        }

                    });


                    const finalTotal = tempPayment.reduce((total, obj) => parseFloat(obj) + parseFloat(total), 0)

                    values.finalPayment = finalTotal.toFixed(2)
                    values.paymentAmount = finalTotal.toFixed(2)
                    values.activeVendorBillSelected = selectedVendorBill

                    const handleUpdatePayment = (e, data, index, object) => {

                        const { setFieldValue } = form

                        setFieldValue(data.name, data.value).then(() => {
                            replace(index, {
                                checkbox: data.value,
                                billDate: object.billDate,
                                vendorBillNo: object.vendorBillNo,
                                billReferenceNo: object.billReferenceNo,
                                vendorCode: object.vendorCode,
                                billDueDate: object.billDueDate,
                                billAmount: object.billAmount,
                                amountDue: object.amountDue,
                                billId: object.billId,
                                payment: data.value ? object.amountDue : ""
                            })
                        })


                    }


                    return (
                        <>
                            <Table unstackable size="large" compact="very" className="w3-small">
                                <Table.Header>
                                    <Table.Row >
                                        <Table.HeaderCell className="labelName p-bold-600"></Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Bill Date</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Partner Bill No</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Partner Branch Name</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Bill Due Date</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Bill Amount</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Amount Due</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Payment</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {activeVendorBills && activeVendorBills.map((object, index) => {
                                        return (
                                            <Table.Row verticalAlign="middle">
                                                <React.Fragment>
                                                    <Table.Cell>
                                                        <Checkbox
                                                            name={`activeVendorBills[${index}].checkbox`}
                                                            inputProps={{
                                                                disabled: viewmode,
                                                                onChange: (e, data) => {
                                                                    handleUpdatePayment(e, data, index, object);
                                                                    setFieldValue("tdsPercentage", "");
                                                                    setFieldValue("tdsFinalAmount", "");
                                                                }
                                                            }}
                                                        />
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {activeVendorBills[index].billDate ? moment(activeVendorBills[index].billDate).format("DD-MM-YYYY") : ""}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {activeVendorBills[index].vendorBillNo}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {activeVendorBills[index].branchName}
                                                    </Table.Cell>
                                                    <Table.Cell >
                                                        {activeVendorBills[index].billDueDate ? moment(activeVendorBills[index].billDueDate).format("DD-MM-YYYY") : "NA"}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {activeVendorBills[index].billAmount}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        {activeVendorBills[index].amountDue}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        <Fieldmik
                                                            name={`activeVendorBills[${index}].payment`}
                                                            value={object.payment}
                                                            disabled={!object.checkbox}
                                                            component={MyNormalInput} />
                                                        <ErrorMessage
                                                            name={`activeVendorBills[${index}].payment`}
                                                        >
                                                            {msg => <Label size="mini" color="red" prompt pointing="left" >{msg}</Label>}
                                                        </ErrorMessage>
                                                    </Table.Cell>

                                                </React.Fragment>
                                            </Table.Row>
                                        )
                                    }
                                    )}
                                </Table.Body>
                            </Table>
                        </>
                    )
                }
                }
            </FieldArray>
            <TDSModal open={modalActive} onClose={() => setModalActive(false)} />
        </div>
    )
}

export default ActiveVendorBills











